import React, {Component} from 'react';
import TimeGrid from '../TimeGrid';
import { ScheduleTimeCell } from './SettingsHoursView';
import moment from 'moment';
import CalendarAppointment from "../Appointments/CalendarAppointment";

export default class CalendarHoursSelectView extends TimeGrid{
    getColumnHeaders(){
        return [<div>Select Calendar Time Range</div>]
    }

    __handleGridItemDrop = (item, bounds, itemId, eventName, layer, touchEvent) => {
        console.log('Item Dropped:', layer, item, bounds)

        const cell = item.item;
        if(this.props.onTimeChange){
            const pos = {
                x: bounds[0],
                y: bounds[1],
                w: bounds[2],
                h: bounds[3]
            }



            let start = this.getTimeFromRow(pos.y);
            let end = this.getTimeFromRow(pos.y + pos.h);

            this.props.onTimeChange(cell.props.day, [start.format('H:mm'), end.format('H:mm')]);

        }
    }

    getItems(){
        let items = {};
        let timeStart = moment(this.props.activeStartTime || '7:00', 'H:mm');
        let timeEnd = moment(this.props.activeEndTime || '21:00', 'H:mm');

        let rowStart = this.getRowFromTime(timeStart);
        let rowEnd = this.getRowFromTime(timeEnd);

        let gridData = this.newGridData();

        gridData.x = 0;//this.getItemCol(app);
        gridData.y = rowStart;
        gridData.h = rowEnd - rowStart;

        items[gridData.i] = {
            item: <ScheduleTimeCell  id={gridData.i} grid={this} timeStart={timeStart} timeEnd={timeEnd} day={0} onTimeChange={this.props.onTimeChange} />,
            bounds: [gridData.x, gridData.y, gridData.w, gridData.h],
            allowResize: true,
            draggable: true
        }

        console.log('SelectView ITems:', items);

        /*
        items.push(
            <div key={gridData.i} data-grid={gridData}>
                <ScheduleTimeCell  id={gridData.i} grid={this} timeStart={timeStart} timeEnd={timeEnd} day={0} onTimeChange={this.props.onTimeChange} />
            </div>)
        */

        return items;
    }
}



// WEBPACK FOOTER //
// ./src/views/Settings/CalendarHoursSelectView.js